import { gateway } from '../../utils/api';

const START_TEMP_RESPONSE_PATH = '/response/tempResponseUser/startTempResponse';
const NO_TIME_LIMIT = 0;
const EMPTY_RESULTS = [null, undefined, 'null', 'undefined'];

export const ENTRANCE_EXAM_START = {
  RESUME: 'RESUME',
  TIME_OVER: 'TIME_OVER',
  NOT_RELEASED: 'NOT_RELEASED'
};

export function startEntranceExamDraft(code) {
  const idProfile = localStorage.getItem('idProfile');
  const tempResponseCode = `RESPONSE_${idProfile}_${code}`;
  return gateway.put(`${START_TEMP_RESPONSE_PATH}?code=${tempResponseCode}`);
}

export function resolveEntranceExamStart(result) {
  if (EMPTY_RESULTS.includes(result) || !result.draft) {
    return { action: ENTRANCE_EXAM_START.NOT_RELEASED };
  }
  const { draft, hasTimeLimit, remainingTimeInSeconds } = result;
  if (!hasTimeLimit) {
    return {
      action: ENTRANCE_EXAM_START.RESUME,
      draft,
      timeLimit: NO_TIME_LIMIT
    };
  }
  if (remainingTimeInSeconds > NO_TIME_LIMIT) {
    return {
      action: ENTRANCE_EXAM_START.RESUME,
      draft,
      timeLimit: remainingTimeInSeconds
    };
  }
  return { action: ENTRANCE_EXAM_START.TIME_OVER, draft };
}

export async function loadEntranceExamDraft({
  code,
  onResume,
  onTimeOver,
  onNotReleased
}) {
  const result = await startEntranceExamDraft(code);
  const start = resolveEntranceExamStart(result);
  if (start.action === ENTRANCE_EXAM_START.RESUME) {
    return onResume(start);
  }
  if (start.action === ENTRANCE_EXAM_START.TIME_OVER) {
    return onTimeOver(start.draft);
  }
  return onNotReleased();
}
